import { render, staticRenderFns } from "./AccountModalHeader.vue?vue&type=template&id=85abd854&scoped=true&"
import script from "./AccountModalHeader.vue?vue&type=script&lang=js&"
export * from "./AccountModalHeader.vue?vue&type=script&lang=js&"
import style0 from "./AccountModalHeader.vue?vue&type=style&index=0&id=85abd854&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85abd854",
  null
  
)

export default component.exports